export default "__VITE_ASSET__bdf00fb4__"